import GPTPlaygroundRoute from "./routes";

export default store => ({
  path: "gptplayground",
  childRoutes: [GPTPlaygroundRoute(store)],
});
